<template>
  <div class="bgmain2 bildschirnansicht">
    <div class="row p-0 my-4 justify-content-center">
      <div class="col-md-6 col-lg-3 cardCenter">
        <div class="card  t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-0">
            <img
              src="../assets/balkenMitBild/Verpackungen.png"
              class="card-img-top"
              alt="..."
            />
            <p class="cardHeader">Verpackung</p>
            <p class="cardHeader2">Flexibel, effizient und passgenau:</p>
            <p class="card-text p-2">
              Ob Standardkarton, Faltkarton oder maßgeschneiderte Lösung.<br />
              Unsere Kartons sind vielseitig einsetzbar
              und bieten optimalen Schutz für den sicheren Versand und die Lagerung Ihrer
              Produkte.
            </p>
            <p class="card-footer">  
              <router-link to="/verpackung" class="btn btn-outline-danger">Informationen</router-link>          
         
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 cardCenter">
        <div class="card  t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-0">
            <img
              src="../assets/balkenMitBild/Polstermaterial.png"
              class="card-img-top"
              alt="..."
            />
            <p class="cardHeader">Polstermaterial</p>
            <p class="cardHeader2">Flexibel, effizient und passgenau:</p>
            <p class="card-text p-2">
              Weich, stark, sicher. Unser Polstermaterial macht den Unterschied.
              Hochwertiges Polstermaterial – sicher verpackt, zuverlässig versandt.
Schützen Sie Ihre Produkte mit Qualität, die ankommt.
            </p>
            <p class="card-footer">
               <router-link to="/polstermaterial" class="btn btn-outline-danger">Informationen</router-link>           
         
            </p>
          </div>
        </div>
      </div>

      <!-- <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-4">
            <p class="cardHeader">Brandschutz&shy;verkleidung</p>
            <p class="cardHeader2">Setzen Sie architektonische Akzente:</p>
            <p class="card-text pt-1">
              Sicherheit für Ihre Immobilie: Wir realisieren professionelle
              Brandschutzmaßnahmen nach aktuellen Normen. Unsere zertifizierten
              Brandschutzverkleidungen erhöhen den Schutz Ihrer Räume und schaffen
              Vertrauen.
            </p>
            <p class="card-footer pt-2">
              <a
                href="#WEBSHOPS"
                class="btn btn-outline-danger"
                tabindex="-1"
                role="button"
                aria-disabled="true"
                >Brandschutz</a
              >
            </p>
          </div>
        </div>
      </div> -->
    </div>

    <div class="row p-0 mb-4 justify-content-center">
      <div class="col-md-6 col-lg-3 cardCenter">
        <div class="card  t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-0">
            <img
              src="../assets/balkenMitBild/Folien.png"
              class="card-img-top"
              alt="..."
            />
            <p class="cardHeader">Folien</p>
            <p class="cardHeader2">Flexibel, effizient und passgenau:</p>
            <p class="card-text p-2">
              Unsere Verpackungsfolien schützen Ihre Produkte zuverlässig vor Feuchtigkeit, Staub und Beschädigungen.
              Ob beim Transport oder bei der Lagerung – auf unsere Qualität können Sie sich verlassen.
              
            </p>
            <p class="card-footer">   
              <router-link to="/folien" class="btn btn-outline-danger">Informationen</router-link>           
         
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 cardCenter">
        <div class="card  t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-0">
            <img
              src="../assets/balkenMitBild/Zubehoer.png"
              class="card-img-top"
              alt="..."
            />
            <p class="cardHeader">Verpackungszubehör</p>
            <p class="cardHeader2">Flexibel, effizient und passgenau:</p>
            <p class="card-text p-2">
              Karton? Check. Folie? Check. Zubehör? Haben wir!
Mit unserem Verpackungszubehör läuft der Versand wie geschmiert.
Schnell, sicher, durchdacht – bis ins kleinste Detail.
            </p>
            <p class="card-footer">
              <router-link to="/verpackungszubehoer" class="btn btn-outline-danger">Informationen</router-link>           
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 cardCenter">
        <div class="card  t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-0">
            <img
              src="../assets/balkenMitBild/Paletten.png"
              class="card-img-top"
              alt="..."
            />
            <p class="cardHeader">Paletten, Holzkisten</p>
            <p class="cardHeader2">Flexibel, effizient und passgenau:</p>
            <p class="card-text p-2">
              Paletten und Holzkisten – die stabile Basis für sicheren Transport.
Für schwere Lasten, lange Wege und höchste Ansprüche.
Vertrauen Sie auf zuverlässige Ladungsträger aus Holz.
            </p>
            <p class="card-footer">
              <router-link to="/paletten" class="btn btn-outline-danger">Informationen</router-link>              
            </p>
          </div>
        </div>
      </div>

      <!-- <div class="col-md-3 cardCenter p-4">
        <div class="card pt-3 t-center hintergrundHell" style="width: 22rem">
          <div class="card-body p-4">
            <p class="cardHeader">Bad&shy;sanierung</p>
            <p class=" cardHeader2 ">Ihr Bad – modern und komfortabel:</p>
            <p class="card-text pt-1">
               Wir verwandeln Ihr Badezimmer in
              eine Wohlfühloase. Von der Planung bis zur Fertigstellung bieten wir
              maßgeschneiderte Lösungen – barrierefrei, stilvoll und hochwertig.
            </p>
            <p class="card-footer pt-2">
              <button
                class="btn btn-outline-danger"
                @click="$router.push('/Kontakt')"
              >
              Badsanierung
              </button>
            </p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
